var map = {
	"./Backend/Auth/Login": 9608,
	"./Backend/Auth/Login.tsx": 9608,
	"./Backend/Dataset/Create": 1352,
	"./Backend/Dataset/Create.tsx": 1352,
	"./Backend/Dataset/Edit": 2407,
	"./Backend/Dataset/Edit.tsx": 2407,
	"./Backend/Dataset/Index": 6647,
	"./Backend/Dataset/Index.tsx": 6647,
	"./Backend/Homepagedata/Create": 1667,
	"./Backend/Homepagedata/Create.tsx": 1667,
	"./Backend/Homepagedata/Edit": 6910,
	"./Backend/Homepagedata/Edit.tsx": 6910,
	"./Backend/Homepagedata/Index": 2680,
	"./Backend/Homepagedata/Index.tsx": 2680,
	"./Backend/Image/Create": 7644,
	"./Backend/Image/Create.tsx": 7644,
	"./Backend/Image/Edit": 25,
	"./Backend/Image/Edit.tsx": 25,
	"./Backend/Image/Index": 992,
	"./Backend/Image/Index.tsx": 992,
	"./Backend/Layout/Layout": 7489,
	"./Backend/Layout/Layout.tsx": 7489,
	"./Backend/Shared/DeleteButton": 582,
	"./Backend/Shared/DeleteButton.tsx": 582,
	"./Backend/Shared/FlashMessages": 5009,
	"./Backend/Shared/FlashMessages.tsx": 5009,
	"./Backend/Shared/Icon": 950,
	"./Backend/Shared/Icon.tsx": 950,
	"./Backend/Shared/LoadingButton": 5773,
	"./Backend/Shared/LoadingButton.tsx": 5773,
	"./Backend/Shared/SelectInput": 683,
	"./Backend/Shared/SelectInput.tsx": 683,
	"./Backend/Shared/TextInput": 3661,
	"./Backend/Shared/TextInput.tsx": 3661,
	"./Backend/User/Create": 7103,
	"./Backend/User/Create.tsx": 7103,
	"./Backend/User/Edit": 3286,
	"./Backend/User/Edit.tsx": 3286,
	"./Backend/User/Index": 5993,
	"./Backend/User/Index.tsx": 5993,
	"./Dataset/Dataset": 955,
	"./Dataset/Dataset.sass": 9265,
	"./Dataset/Dataset.tsx": 955,
	"./Home/Home": 3646,
	"./Home/Home.sass": 5627,
	"./Home/Home.tsx": 3646
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7732;